import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StoreInvoiceCountryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StoreInvoiceCountryQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, invoice_run_country?: string | null } | null };


export const StoreInvoiceCountryDocument = gql`
    query storeInvoiceCountry($id: ID!) {
  store(id: $id) {
    id
    invoice_run_country
  }
}
    `;

/**
 * __useStoreInvoiceCountryQuery__
 *
 * To run a query within a React component, call `useStoreInvoiceCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreInvoiceCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreInvoiceCountryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStoreInvoiceCountryQuery(baseOptions: Apollo.QueryHookOptions<StoreInvoiceCountryQuery, StoreInvoiceCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreInvoiceCountryQuery, StoreInvoiceCountryQueryVariables>(StoreInvoiceCountryDocument, options);
      }
export function useStoreInvoiceCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreInvoiceCountryQuery, StoreInvoiceCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreInvoiceCountryQuery, StoreInvoiceCountryQueryVariables>(StoreInvoiceCountryDocument, options);
        }
export type StoreInvoiceCountryQueryHookResult = ReturnType<typeof useStoreInvoiceCountryQuery>;
export type StoreInvoiceCountryLazyQueryHookResult = ReturnType<typeof useStoreInvoiceCountryLazyQuery>;
export type StoreInvoiceCountryQueryResult = Apollo.QueryResult<StoreInvoiceCountryQuery, StoreInvoiceCountryQueryVariables>;